import { render, staticRenderFns } from "./language_selection.vue?vue&type=template&id=109ddbbe&"
import script from "./language_selection.vue?vue&type=script&lang=js&"
export * from "./language_selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports